












































































































import SwipeBtn from "@/components/SwipeBtn.vue";
import { token, useFilters } from "@/lib/format";
import { handleError } from "@/lib/error-handling";
import { Wallet } from "@/models/wallet";
import {
  computed,
  defineComponent,
  onBeforeMount,
  onMounted
} from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter } from "@/hooks/use-router";

export default defineComponent({
  components: {
    SwipeBtn
  },
  setup() {
    const { store } = useVuex();
    const router = useRouter();
    const loading = computed(() => store.state.Loading.loading);
    const pendingTransaction = computed(
      () => store.state.Wallet.pendingTransaction
    );
    const sending = computed(() => store.state.Wallet.sending);
    const wallet = computed(() => store.getters.Wallet.wallet as Wallet);

    onBeforeMount(() => {
      if (!pendingTransaction.value || !wallet.value)
        router.push("/wallet/send");
    });

    onMounted(() => {
      store.commit.Loading.stopLoading();
    });

    const swipeText = computed(() => {
      const amount = token(
        !pendingTransaction.value ? 0 : pendingTransaction.value.amount || 0,
        wallet.value.network.symbol || "",
        wallet.value.network.decimals || 0
      );
      return `Swipe to send ${amount}`;
    });

    const submit = async () => {
      const receiverIsMe = store.state.Wallet.wallets.find(
        w => w.address === pendingTransaction?.value?.to
      );

      if (!pendingTransaction.value) return;
      try {
        await store.dispatch.Wallet.send();
        store.commit.Wallet.setPendingTx(null);
        router.push("/wallet");
        if (receiverIsMe) {
          setTimeout(
            () =>
              store.dispatch.Wallet.updateWallet({
                address: receiverIsMe.address
              }),
            3000
          );
        }
      } catch (error) {
        handleError(error, `Sending timed out`);
      }
    };

    return {
      ...useFilters(),
      loading,
      pendingTransaction,
      sending,
      wallet,
      swipeText,
      submit
    };
  }
});
